import React from 'react'
import Navbar from '../containers/Navbar/Navbar.container'
import ManagementMenu from '../containers/ManagementMenu/ManagementMenu.container'
import routes from '../config/settings/routes'
import ProtectBySession from '../components/Security/ProtectBySession'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import { LassoPolygon, MapBoundary } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem, Stack } from '@carbon/react'
import { Iframe } from '../containers/Map/Map.styles'
import { CardComponent } from '../components/Layouts/Card.styles'
import Card from '../components/Layouts/Card';
import Typography from '../components/Basics/Typography'
import InformationContainer from '../components/Basics/Information.container'
import SimpleCesiumFallback from '../components/TruckMap3D'
import CesiumV2 from '../containers/CesiumMap/CesiumMap'

/**
 * The Map's Page.
 */
const CesiumMap = () => {
  const CesiumBreadCrumbs = () => {
    return (
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem>
          <a href="/#">UCO</a>
        </BreadcrumbItem>
        <BreadcrumbItem href="#" isCurrentPage>Mapa 3D</BreadcrumbItem>
      </Breadcrumb>
    )
  }

  const title = 'Mapa 3D'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <BrandLayout
        navbar={<Navbar managementMenu={<ManagementMenu current={routes.cesium} />} />}
        header={<Heading title={title} icon={<LassoPolygon size={50} />} breadcrumbs={<CesiumBreadCrumbs />} tooltipContent='Vista para visualizar puntos utilizando Cesium.'/>}
      >
        <Stack gap={3}>
        <CesiumV2 />

        </Stack>
      </BrandLayout>
    </ProtectBySession>
  )
}

export default CesiumMap
